export const transformPathWithSpecialCharacters = (path: string): string => {
  const transformedPathString = path
    .replaceAll(/[!#/:]+/g, "") // remove all instances of "!", "#", "/", and ":"
    .replaceAll(/[\s.]+/g, "-") // replace all instances of " " and "." with "-"
    .replaceAll("+", "-plus-") // replace all instances of "+" with "-plus-"
    .replaceAll(/-+/g, "-") // replace all consecutive instances of "-" with a single "-"
    .replace(/-$/, ""); // remove trailing "-"

  const transformedLowercasePathString = transformedPathString.toLowerCase();

  return transformedLowercasePathString;
};
